import https from "@/utils/https";
export const getClassList = (params: any) => {
  return https.get({
    url: "/web/class/list",
    params,
  });
};

export const getProductList = (params: any) => {
  return https.get({
    url: "/web/product/list",
    params,
  });
};
